import React, {Suspense} from 'react';
import {Redirect, Switch} from 'react-router-dom';
import {shallowEqual, useSelector} from 'react-redux';
import {LayoutSplashScreen} from '../_metronic/layout';
import {Users} from './pages/UsersPage';
import {RegistrationData} from './pages/RegistrationDataPage';
import {UserDetails} from './pages/UserDetailsPage';
import {AutomatedPaymentsPage} from './pages/AutomatedPaymentsPage';
import {Invoices} from './pages/InvoicesPage';
import {InvoiceOrders} from './pages/InvoiceOrdersPage';
import {Receipts} from './pages/ReceiptsPage';
import {CompleteDetailsPage} from './pages/CompleteDetailsPage';
import {Partners} from './pages/PartnersPage';
import {InvitedUsers} from './pages/InvitedUsersPage';
import {Customers} from './pages/CustomersPage';
import {AgentsInvoices} from './pages/AgentsIncomesPage';
import {Projects} from './pages/ProjectsPage';
import {UnpaidAgents} from './pages/UnpaidAgentsPage';
import {TransfersByAgent} from './pages/TransfersByAgentPage';
import {UsersActionsPage} from './pages/UsersActionsPage';
import {PaypalRequestsPage} from './pages/PaypalRequestsPage';
import {TransfersPage} from './pages/TransfersPage';
import {BankStatementsPage} from './pages/BankStatementsPage';
import {NotificationsPage} from './pages/NotificationsPage';
import {LawPage} from './pages/LawPage';
import {UsersClientActionsPage} from './pages/UsersClientActionsPage';
import {AiReportsPage} from './pages/AiReportsPage';
import {ProtectedRoute} from './modules/_common/components/Permissions';

export default function BasePage() {
  const {defaultPage} = useSelector(({auth}) => auth, shallowEqual);

  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <Redirect exact from="/" to={defaultPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="agentsIncomesPage" path="/agents-incomes"
                        component={AgentsInvoices}/>
        <ProtectedRoute defaultPage={defaultPage} subject="bituahLeumiPayment" path="/automated-payments"
                        component={AutomatedPaymentsPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="completeDetails" path="/complete-details"
                        component={CompleteDetailsPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="customersPage" path="/customers" component={Customers}/>
        <ProtectedRoute defaultPage={defaultPage} subject="invitedUsersPage" path="/invited-users"
                        component={InvitedUsers}/>
        <ProtectedRoute defaultPage={defaultPage} subject="invoiceOrders" path="/invoice-orders"
                        component={InvoiceOrders}/>
        <ProtectedRoute defaultPage={defaultPage} subject="invoices" path="/invoices" component={Invoices}/>
        <ProtectedRoute defaultPage={defaultPage} subject="partners" path="/partners" component={Partners}/>
        <ProtectedRoute defaultPage={defaultPage} subject="projectsPage" path="/projects" component={Projects}/>
        <ProtectedRoute defaultPage={defaultPage} subject="receipts" path="/receipts" component={Receipts}/>
        <ProtectedRoute defaultPage={defaultPage} subject="registrationPage" path="/registration-data"
                        component={RegistrationData}/>
        <ProtectedRoute defaultPage={defaultPage} subject="transfersByAgentPage" path="/transfersByAgent/:agentId"
                        component={TransfersByAgent}/>
        <ProtectedRoute defaultPage={defaultPage} subject="unpaidAgentsPage" path="/unpaid-agents"
                        component={UnpaidAgents}/>
        <ProtectedRoute defaultPage={defaultPage} subject="userPage" path="/user/:userId" component={UserDetails}/>
        <ProtectedRoute defaultPage={defaultPage} subject="usersPage" path="/users" component={Users}/>
        <ProtectedRoute defaultPage={defaultPage} subject="usersActionsPage" path="/logs-users-actions"
                        component={UsersActionsPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="paypalRequestsPage" path="/paypal-requests"
                        component={PaypalRequestsPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="transfersPage" path="/all-transfers"
                        component={TransfersPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="bankStatementsPage" path="/bank-statements"
                        component={BankStatementsPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="notificationsPage" path="/notifications-center"
                        component={NotificationsPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="lawPage" path="/lawsuit"
                        component={LawPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="usersClientActionsPage" path="/logs-users-client-actions"
                        component={UsersClientActionsPage}/>
        <ProtectedRoute defaultPage={defaultPage} subject="aiReportsPage" path="/ai-reports"
                        component={AiReportsPage}/>
      </Switch>
    </Suspense>
  );
}
